import { useEffect, useRef } from 'react';
import { ESCAPE_KEY } from 'src/modules/assistant/constants/widget';

export const useEscapeKey = (enabled: boolean, onEscape: () => void) => {
    const onEscapeRef = useRef(onEscape);
    onEscapeRef.current = onEscape;

    useEffect(() => {
        if (!enabled) return undefined;
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === ESCAPE_KEY) onEscapeRef.current();
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [enabled]);
};
